import { ExternalLink } from '@sales-center/components'
import Box from '@mui/material/Box'
import * as React from 'react'
import { useData } from './hooks/useData'

type Props = {
  billToId: string
  externalLocationId: string
}

export function SubHeader(props: Props) {
  const { billToId } = props
  const { externalLinkLabel, locationUrl } = useData(props)

  return billToId ? (
    <Box ml={2}>
      <ExternalLink
        fontSize={14}
        href={locationUrl}
        label={externalLinkLabel}
      />
    </Box>
  ) : null
}
